import { Component, input, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnerMttdResponse, QueryType } from 'src/app/core/services/analytics.service';
import { MttdDetailsService } from './services/mttddetails.service';
import { environment } from 'src//environments/environment';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { GridModule, ExcelModule, GridDataResult } from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs';
import { DATE_FILTER_OPERATORS } from 'src/app/core/constants/filter-operators';

@Component({
  selector: 'app-mttd-card',
  standalone: true,
  imports: [CommonModule, DialogsModule, GridModule, ExcelModule],
  templateUrl: './mttd-card.component.html',
  styleUrl: './mttd-card.component.scss',
  providers: [MttdDetailsService],
})
export class MttdCardComponent {
  // New signal input for the API response
  partnerMttd = input<PartnerMttdResponse>(new PartnerMttdResponse());

  // Keep old inputs for backward compatibility
  @Input() meanTimeToDetect: number = 0;
  @Input() previousMeanTimeToDetect: number = 0;

  public readonly gridService = inject(MttdDetailsService);
  public showPopup = false;
  public organizationId = input<number | null>();
  public startDate = input<string | null>();
  public endDate = input<string | null>();
  public dateFilterOperators = DATE_FILTER_OPERATORS;
  queryType = input<QueryType>(QueryType.All);
  selectedOrgIds = input<number[]>([]);

  public Math = Math;

  onContextMenuSelect(event: any) {
      if (event?.text === 'View Data') {

        // Determine query type and org IDs based on filter context
        const queryType = this.queryType().toLowerCase(); // 'all' or 'filtered'
        const orgIds = this.queryType() === QueryType.Filtered && this.selectedOrgIds().length > 0 
          ? this.selectedOrgIds().join(',') 
          : this.organizationId();
  
        const baseQueryString = `org_ids=${orgIds}&type=${queryType}`;
        const queryString = `${baseQueryString}&current_start=${this.startDate()}&current_end=${this.endDate()}`;
  
        this.gridService.url = `${environment.apiUrl}/v1/analytics/administrative/mttdmetricsdetails(${this.organizationId()})`;
        this.gridService.appendQueryString = queryString;
        this.gridService.read();
        this.showPopup = true;
      } else {
        console.warn('Invalid event structure:', event);
      }
  }


  public allData = (): Observable<GridDataResult> => {
    return this.gridService.queryAll();
  };

  // Close popup
  close() {
    this.showPopup = false;
  }


}
